import { SET_APP_CURRENT_PATH } from '../../constants/actionTypes';
import AnalyticsUtils from '../../lib/AnalyticsUtils';

export const setCurrentPath = (newPath) => (dispatch, getState) => {
  const {
    routes: { currentPath },
  } = getState();
  if (newPath !== currentPath) {
    AnalyticsUtils.trackPageTransition(newPath);
    return dispatch({
      type: SET_APP_CURRENT_PATH,
      payload: {
        currentPath: newPath,
      },
    });
  }
};
